import {
    authorizationServicesPath,
} from "../../Constants";
import axios from "axios";

const restUrl = authorizationServicesPath + '/organizations'

export default class OrganizationService {

    static async getAll() {
        return axios.get(restUrl + "/for-settings");
    }

    static async edit(data, id) {
        const addressId = data.address?.id;
        const residentialAddressId = data.residentialAddress?.id;
        return axios.put(
            `${restUrl}/${id}?addressId=${addressId}&residentialAddressId=${residentialAddressId}`,
            JSON.stringify(data),
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            },
        );
    }

    static async setCurrency(baseCurrencyId, alternativeCurrencyId) {
        return axios.patch(restUrl + "/organization-settings/set-currency?baseCurrencyId=" + baseCurrencyId + "&alternativeCurrencyId=" + alternativeCurrencyId, [], {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }
}